<template>
  <div class="offer-position-boilerplates">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <OfferPositionBoilerplatesTable
      @create-offer-position-boilerplate="onCreateOfferPositionBoilerplate"
    />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import OfferPositionBoilerplatesTable from '@/components/OfferPositionBoilerplates/OfferPositionBoilerplatesTable';

export default {
  name: 'OfferPositionBoilerplates',
  components: {
    Breadcrumbs,
    OfferPositionBoilerplatesTable,
  },
  computed: {
    breadcrumbs() {
      return [
        { name: 'Home', route: { name: 'home' } },
        { name: this.$t('offerPositionBoilerplates') },
      ];
    },
  },
  methods: {
    onCreateOfferPositionBoilerplate() {
      this.$router.push({ name: 'OfferPositionBoilerplateCreatePage' });
    },
  },
};
</script>

<style lang="scss"></style>
